// extracted by mini-css-extract-plugin
export default {"summary":"AccordionButton__summary Button__base Button__inputButton inputButton","dropArrow":"AccordionButton__dropArrow brandColor__font"};